/**
 * The brand-gradient wash (DD-012) — single source for every surface that
 * wears it (TabGroup track, header client selector, every Button: J13).
 * Faint by design; do not bump opacities per call site.
 */
export const BRAND_GRADIENT_TRACK =
  "bg-gradient-to-r from-indigo-400/10 via-purple-400/10 to-fuchsia-400/10";

/** A Button's hover: the same wash, twice as strong (J13). */
export const BRAND_GRADIENT_HOVER =
  "hover:from-indigo-400/20 hover:via-purple-400/20 hover:to-fuchsia-400/20";
